import { createSlice } from "@reduxjs/toolkit";
import { deleteStudy, getStudy, undoDeleteStudy } from "./study.api";

const studySlice = createSlice({
  name: "study",
  initialState: {
    study: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.study.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStudy.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getStudy.fulfilled, (state, action) => {
      state.loading = false;
      state.study = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getStudy.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteStudy.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteStudy.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.study.data) {
        state.study.data = state.study.data.filter((study) => {
          return study._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error("state.study.data is not an array:", state.study.data);
      }
      state.loading = false;
    });
    builder.addCase(deleteStudy.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteStudy.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteStudy.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.study.data) {
        state.study.data = state.study.data.filter((study) => {
          return study._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error("state.study.data is not an array:", state.study.data);
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteStudy.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = studySlice.actions;
export default studySlice.reducer;
